module.exports = __webpack_public_path__ + "static/img/img_m.ebef806a.png";